export const ContractPlaceholderLegend = ({ fields, onInsert }) => (
  <aside className="min-w-0 border-l border-[#E5E5E0] pl-5 lg:sticky lg:top-5 lg:self-start" data-testid="contract-placeholder-legend">
    <h2 className="font-serif text-lg text-[#1A1A1A] mb-2">Dati inseribili</h2>
    <div className="space-y-1 max-h-96 lg:max-h-[calc(100dvh-6rem)] overflow-y-auto pr-1" data-testid="contract-placeholder-list">
      {fields.map((field) => (
        <button key={field.key} type="button" onMouseDown={(event) => event.preventDefault()}
                onClick={() => onInsert(field.token)} title={`Inserisci ${field.label}`}
                className="block w-full text-left py-2 px-2 -mx-2 border-b border-[#F0F0EA] hover:bg-[#F5F2EC] transition-colors"
                aria-label={`Inserisci ${field.label}`}
                data-testid={`contract-placeholder-${field.key}`}>
          <span className="block text-sm text-[#1A1A1A]">{field.label}</span>
          <code className="text-[11px] text-[#8C3A3A] break-all">{field.token}</code>
        </button>
      ))}
    </div>
  </aside>
);